export enum FooterDialogsActions {
    CLOSE_APPLICATION,
    END_SHIFT,
    SIGN_OFF_WORKSTATION,
    MANAGE_ASSISTANTS,
    CANCEL,
}
